<template>
    <div id="regBylink-container">
        <v-row class="px-2">
            <v-col lg="6" md="6" sm="12" xs="12" offset-lg="3" offset-md="3" offset-sm="0" justify="center" class="pa-0">

                <v-overlay :value="loading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <v-col v-if="logo" align="center">
                    <v-img :src="require(`@/assets/${logo}`)" width="100"></v-img>
                </v-col>

                <svg v-show="card.cardNumber.startsWith('4')" id="svg-visa" class="reg-form-svg" viewBox="0 0 100 44">
                    <text id="card-number" class="card-items" x="17.8" y="27" font-size="0.354em">{{ card.cardNumber }}</text>
                    <text id="card-holder" class="card-items" x="18" y="34" font-size="0.25em">{{ card.holder }}</text>
                    <text id="card-expiry" class="card-items" x="18" y="41" font-size="0.25em">{{ card.expiry }}</text>
                    <text id="card-cvv" class="card-items" x="75" y="34" font-size="0.25em">{{ card.cvv }}</text>
                </svg>

                <svg v-show="card.cardNumber.startsWith('5')" id="svg-mastercard" class="reg-form-svg" viewBox="0 0 100 44">
                    <text id="card-number" class="card-items" x="17.8" y="27" font-size="0.354em">{{ card.cardNumber }}</text>
                    <text id="card-holder" class="card-items" x="18" y="34" font-size="0.25em">{{ card.holder }}</text>
                    <text id="card-expiry" class="card-items" x="18" y="41" font-size="0.25em">{{ card.expiry }}</text>
                    <text id="card-cvv" class="card-items" x="75" y="34" font-size="0.25em">{{ card.cvv }}</text>
                </svg>
                
                <svg v-show="!card.number || (!card.number.startsWith('4') && !card.number.startsWith('5'))" id="svg-blank" class="reg-form-svg" viewBox="0 0 100 44">
                    <text v-if="reg && reg.processed == 0" id="card-number" class="card-items" x="17.8" y="27" font-size="0.354em">{{ card.cardNumber }}</text>
                    <text v-else id="card-number" class="card-items" x="29" y="30" font-size="0.354em">Link Expired</text>
                    <text id="card-holder" class="card-items" x="18" y="34" font-size="0.25em">{{ card.holder }}</text>
                    <text id="card-expiry" class="card-items" x="18" y="41" font-size="0.25em">{{ card.expiry }}</text>
                    <text id="card-cvv" class="card-items" x="75" y="34" font-size="0.25em">{{ card.cvv }}</text>
                </svg>

                <v-col v-if="reg && reg.processed != 1" md="12" class="reg-form-col">
                    <v-card class="reg-form-card">
                        <v-card-title class="px-3">Card Details</v-card-title>
                        <v-divider></v-divider>
                        <v-form ref="form" lazy-validation @submit="onSubmit">
                            <div class="px-4 py-2 pb-2">
                                <v-row>
                                    <!-- Reference -->
                                    <v-col md="12" class="py-0">
                                        <v-text-field
                                            v-model="card.merchantTransactionId"
                                            label="Reference"
                                            readonly
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <!-- Card Number -->
                                    <v-col md="12" class="py-0">
                                        <v-text-field
                                            v-model="card.cardNumber"
                                            label="Card Number"
                                            v-mask="masks.number"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <!-- Card Holder -->
                                    <v-col md="12" class="py-0">
                                        <v-text-field
                                            v-model="card.holder"
                                            label="Card Holder"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
        
                                <v-row>
                                    <!-- Expiry -->
                                    <v-col md="6" class="py-0">
                                        <v-text-field
                                            v-model="card.expiry"
                                            label="Expiry"
                                            v-mask="masks.expiry"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>

                                    <!-- CVV -->
                                    <v-col md="6" class="py-0">
                                        <v-text-field
                                            v-model="card.cvv"
                                            label="CVV"
                                            v-mask="masks.cvv"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <!-- Address 1 -->
                                    <v-col md="12" class="py-0">
                                        <v-text-field
                                            v-model="card.address1"
                                            :rules="[rules.required]"
                                            label="1st Line Address"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <!-- Postcode -->
                                    <v-col md="12" class="py-0">
                                        <v-text-field
                                            v-model="card.postcode"
                                            label="Postcode"
                                            :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                            
                            <v-divider></v-divider>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" type="submit">Register</v-btn>
                            </v-card-actions>
                        </v-form>        
                    </v-card>

                    <v-row v-if="result && result.result.code == '000.000.000'" class="mt-4">
                        <v-col md="12" class="py-0">
                            <v-alert
                                type="success"
                                text border="left"
                                dismissible
                                class="mb-2">
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-row v-else-if="result && result.result.code != '000.000.000'" class="px-4">
                        <v-col md="12" class="">
                            <v-alert type="error" text border="left" dismissible>
                                Code: {{ result.result.code }}<br>
                                Description: {{ result.result.description }}
                            </v-alert>
                        </v-col>
                    </v-row>
                </v-col>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';

export default {
    directives: { mask },
    data() {
        return {
            reg: null,
            card: {
                merchantTransactionId: null,
                cardNumber: '',
                holder: '',
                expiry: '',
                cvv: '',
                address1: null,
                postcode: null
            },
            currencies: [{ value: 'EUR', text: 'EUR' },
                         { value: 'GBP', text: 'GBP' }],
            masks: {
                number: '#### #### #### ####',
                expiry: '##/##',
                cvv: '###'
            },
            rules: {
                required: v => !!v || 'Required.',
            },
            result: null,
            loading: false,
            logo: null
        }
    },
    computed: {

    },
    beforeMount() {
        this.clicked();
        this.getRegistration();
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            if(this.$refs.form.validate()) {
                axios({
                method: 'post',
                url: 'register-card-live',
                data: { card: this.card,
                        entityId: this.reg.channelUuid,
                        client: { id: this.reg.clientId, merchantCustomerId: this.reg.merchantTransactionId},
                        userId: this.reg.createdBy,
                        rblId: this.reg.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.result = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getRegistration() {
            axios({
                method: 'post',
                url: 'get-reg-by-link',
                data: { token: this.$route.params.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(this.reg);
                    this.card.merchantTransactionId = response.data[0].merchantTransactionId;
                    this.logo = response.data[0].logo;
                    this.reg = response.data[0];
                    console.log(this.reg);
                })
                .catch(e => {
                    this.errors.push(e)
            })
        },
        clicked() {
            axios({
                method: 'post',
                url: 'reg-by-link-clicked',
                data: { token: this.$route.params.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {

                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style scoped>
    #regBylink-container {
        margin-left: -55px;
    }

    .card-items {
        font-family: 'Courier New', Courier, monospace;
        font-weight: 600;
        fill: #fff;
    }

    #svg-visa {
        background: url('../assets/tp-card-blank-visa.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }

    #svg-mastercard {
        background: url('../assets/tp-card-blank-mastercard.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }
    
    #svg-blank {
        background: url('../assets/tp-card-blank.png') no-repeat;
        background-position: center;
        background-size: 70%;
    }

    .reg-form-svg {
        z-index: 10;
        position: relative;
    }

    .reg-form-col {
        z-index: 0;
        position: relative;
        margin-top: -25%;

    }

    .reg-form-card {
        padding-top: 25% !important;
    }
</style>